import { IconCacheService } from '@finxone-platform/shared/services';

export function iconNameToSvg(
  iconName: string,
  width: string | undefined,
  height: string | undefined,
  iconCacheService: IconCacheService,
): string {
  const svgText = iconCacheService.getIcon(iconName);
  if (!svgText) {
    return '';
  }

  // Parse the SVG string into a DOM element
  const parser = new DOMParser();
  const doc = parser.parseFromString(svgText, 'image/svg+xml');
  const svgElement = doc.querySelector('svg');

  if (!svgElement) {
    throw new Error('Invalid SVG content');
  }

  // Set width and height attributes if provided
  if (typeof width === 'string') {
    svgElement.setAttribute('width', width);
  }
  if (typeof height === 'string') {
    svgElement.setAttribute('height', height);
  }

  // Serialize the modified SVG back to a string
  const serializer = new XMLSerializer();
  return serializer.serializeToString(svgElement);
}
